<template>
  <div ref="subGlobal" class="global-main global-shadow">

    <div class='global-panel' v-loading.body="loading.main" style="padding: 10px">
      <div class="global-header">
        <div class="global-title">成绩导出</div>
        <div class='global-tbar'>
          <el-button size="small" type="success"  @click="exportScore()">导 出 成 绩</el-button>
          <el-button size="small" type="primary"  @click="findByCondition()">刷 新</el-button>
        </div>
      </div>
      <hr>
      <div class='global-body'>
        <el-row>
          <el-col :span="24">
            <el-card shadow="hover" style="margin: 10px;">
            <div class="global-paging" v-show="paging.allNum > paging.everySize" >
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
            <el-table :data="taskList" border stripe style="width: 100%" size="mini" @selection-change="handleSelectionChange">
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column type="selection" width="55"/>
              <el-table-column prop="taskName" label="任务名称" sortable></el-table-column>
              <el-table-column prop="taskType" label="任务类型" sortable></el-table-column>
              <el-table-column prop="taskStatus" label="状态">
                <template slot-scope="scope">
                  <el-tag v-show="scope.row.taskStatus=='未开始'" type="success">{{scope.row.taskStatus}}</el-tag>
                  <el-tag v-show="scope.row.taskStatus=='进行中'" type="danger">{{scope.row.taskStatus}}</el-tag>
                  <el-tag v-show="scope.row.taskStatus=='已结束'" type="info">{{scope.row.taskStatus}}</el-tag>
                  <el-tag v-show="scope.row.taskStatus=='已冻结'" type="info">{{scope.row.taskStatus}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="startTime" label="开始时间" sortable></el-table-column>
              <el-table-column prop="endTime" label="结束时间" sortable show-overflow-tooltip></el-table-column>
            </el-table>
            <!-- 分页  -->
            <div v-show="paging.allNum > paging.everySize" class="global-paging">
              <hr/>
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ScoreTask',
  data() {
    return {
      // 遮罩
      loading: {main: false},
      // 可见
      visible: {param: false},
      paging: {currPage: 1, everySize: 20, allNum: 0},

      taskList: [],
      // 查询条件
      condition: {taskName: ''},
      // 当前记录
      currentRecords: []
    }
  },

  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight - vm.$baize.frameTitleHeight) + 'px';
    vm.findByCondition();
  },

  methods: {
    /**
     * 按条件查询
     */
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = {}
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      // 请求后台
      vm.$http.get('rest/scoreTask/findForExportScore', {params: params}).then(response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 更新数据
        vm.taskList = response.body.taskList;
        vm.paging = response.body.pagingBean;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    handleSelectionChange(selectedRows) {
      this.currentRecords = selectedRows;
    },
    // 导出成绩
    exportScore: function () {
      var vm = this;
      if (vm.currentRecords.length == 0) {
        vm.$notify({position: 'bottom-right', type: 'warning', message: '请选择要导出的任务'});
        return;
      }
      // 获取所有成绩ID
      var ids = [];
      for (var i = 0; i < vm.currentRecords.length; i++) {
        ids.push(vm.currentRecords[i].id);
      }
      // 开启遮罩
      vm.loading.main = true;
      let xhr = new XMLHttpRequest();
      xhr.open('POST', '/rest/scoreTask/exportScore', true);
      xhr.responseType = 'arraybuffer';
      xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
      xhr.onreadystatechange = function (event) {
        if (this.readyState == 4 && this.status == 200) {
          // 关闭遮罩
          vm.loading.main = false;
          let contentDisposition = xhr.getResponseHeader('Content-Disposition');
          let index = contentDisposition.indexOf("attachment; filename=");
          let fileName = "未知文件"
          if (index >= 0) {
            fileName = contentDisposition.substring(index + 21);
          }
          //生成Blob对象，通过创建的a标签点击下载
          var objectUrl = URL.createObjectURL(new Blob([this.response]));
          var link = document.createElement("a");
          link.download = decodeURIComponent(fileName);
          link.href = objectUrl;
          link.click();
        } else if (this.readyState == 4 && this.status != 200) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '下载失败'});
          vm.$baize.handle(vm, {status: this.status, body: this.response});
        }
      };
      xhr.send(JSON.stringify({id:ids}));
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

</style>



// WEBPACK FOOTER //
// src/app/ScoreExport.vue